export default __webpack_public_path__ + "static/table_es-4655d3d37f63143a21ca6ca11165b2c3.png";